import { Card, Grid, TextField } from "@mui/material";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import WDTypography from "../../../../MaterialComponents/WDTypography";
import AppService from "../../../../Configurations/Appservice";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  showSuccessMessage,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";

const initialValues = {
  userName: "",
  password: "",
};

const validationSchema = object({
  userName: string().required("User Name is Mandatory"),
  password: string().required("New Password is Mandatory"),
});

const ChangePassword = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateScreenTitle("Change Password"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  const _onSubmit = (values, { resetForm }) => {
    dispatch(showLoader());
    AppService.put("v1/user/changePassword", values)
      .then((response) => {
        dispatch(showSuccessMessage(response));
        resetForm();
      })
      .catch((error) => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  };

  const _create = (values, { resetForm }) => {};

  return (
    <WDBox py={1}>
      <Card sx={{ padding: 3 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={_onSubmit}
          validationSchema={validationSchema}
        >
          {({ errors, isValid, touched, dirty }) => (
            <Form>
              <WDBox>
                <WDTypography fontSize={14}>Change Password</WDTypography>
              </WDBox>
              <WDBox my={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="userName"
                        label="User Name"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.userName) && Boolean(touched.userName)}
                        helperText={Boolean(touched.userName) && errors.userName}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="password"
                        label="New Password"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.password) && Boolean(touched.password)}
                        helperText={Boolean(touched.password) && errors.password}
                      />
                    </WDBox>
                  </Grid>
                </Grid>
              </WDBox>
              <WDBox display="flex" justifyContent="flex-end" pt={3}>
                <WDButton variant="gradient" disabled={!dirty || !isValid} type="submit">
                  Submit
                </WDButton>
              </WDBox>
            </Form>
          )}
        </Formik>
      </Card>
    </WDBox>
  );
};

export default ChangePassword;
